module.exports = __webpack_public_path__ + "static/img/banner-oportunidades-home-1024x768.4e107e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-oportunidades-home-1024x768.jpg
// module id = M5Y7
// module chunks = 47